import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderButtonTitle = (props: Props) => {
  const { children, color = theme.colors.DARK_KALE, style, ...restProps } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const titleDynamicStyles = useStyle(() => {
    return { color };
  }, [color]);

  const titleStyles = [styles.title, titleDynamicStyles, style];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <BodyText
      bold
      maxFontSizeMultiplier={1.2}
      numberOfLines={1}
      sizeMatch={['14']}
      style={titleStyles}
      {...restProps}
    >
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  color?: string;
} & ComponentProps<typeof BodyText>;
